module.exports = __webpack_public_path__ + "static/face-effects-for-web-f1233ad00b75bf50b511ce44afca5c72.mp4";